import React from 'react';
import PropTypes from 'prop-types';

import numeral from '../../../../config/numeral';

import CustomLabelText from './CustomLabelText';

const marginRight = 10;

const CustomYAxisLabel = ({ x, y, color, payload, unit, currencyUnit }) => (
  <svg>
    <CustomLabelText
      x={x - marginRight}
      y={y}
      text={
        unit && payload.value === 0
          ? currencyUnit
            ? numeral(payload.value).format('$0,0.[00]')
            : `${payload.value} ${unit}`
          : payload.value
      }
      color={color}
      atEnd
    />
  </svg>
);

CustomYAxisLabel.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  color: PropTypes.string.isRequired,
  payload: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  unit: PropTypes.string,
  currencyUnit: PropTypes.bool
};

export default CustomYAxisLabel;
